import { useMemo } from "react";
import { isPlainObject } from "lodash";

import { useBuildSearchParams } from "routes/hooks";

import { useFeatures } from "components/FeatureFlag";

export function useCancellationSurvey(user = {}) {
  const buildSearchParams = useBuildSearchParams();

  const emptyForm = useMemo(() => {
    return { url: "", params: [] };
  }, []);

  const form = useFeatures("subscription-cancellation-survey", emptyForm);

  return () => {
    if (!form.url) return;

    const params = buildSearchParams(
      form.params.map((p) => {
        if (isPlainObject(user) && p in user) return [p, user[p]];
        return [];
      })
    );

    window.open(`${form.url}?${params}`, "_self");
  };
}

export default useCancellationSurvey;
